import { Visibility, VisibilityOff } from '@mui/icons-material'
import { FormControlLabel, IconButton, InputAdornment, TextField } from '@mui/material'
import { IconClose } from 'assets/icons'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const ItemFormText = ({
    autoFocus = false,
    label,
    labelKey,
    multiline = false,
    name,
    password = false,
    required = false,
    rules,
    ...props
}) => {
    const { t } = useTranslation()
    const [showPassword, setShowPassword] = useState(false)
    const { register, setValue, watch, formState: { errors } } = useFormContext()
    const {
        minRows = 2,
        maxRows = 4,
        labelPlacement = "start",
        iconEnd,
        disabled,
        readOnly = false,
        trimOnBlur = true,
        type = "text",
        InputProps,
        inputProps,
        ...textFieldProps
    } = props

    const value = watch(name)
    const error = errors?.[name]
    const fieldRegister = register(name, rules)
    const textFieldType = password ? (showPassword ? 'text' : 'password') : type

    return (
        <FormControlLabel
            label={labelKey ? t(labelKey) : label}
            labelPlacement={labelPlacement}
            sx={props?.sx}
            control={
                <TextField
                    {...fieldRegister}
                    {...textFieldProps}
                    required={required}
                    autoFocus={autoFocus}
                    multiline={multiline}
                    minRows={minRows}
                    maxRows={maxRows}
                    type={textFieldType}
                    error={!!error}
                    disabled={disabled}
                    fullWidth
                    helperText={error ? t(error.message) : ''}
                    inputProps={{
                        ...inputProps,
                        readOnly
                    }}
                    onBlur={(e) => {
                        fieldRegister.onBlur(e)
                        textFieldProps.onBlur?.(e)
                        if (trimOnBlur) {
                            setValue(name, watch(name)?.trim())
                        }
                    }}
                    onChange={(e) => {
                        fieldRegister.onChange(e)
                        textFieldProps.onChange?.(e)
                    }}
                    InputProps={{
                        ...InputProps,
                        endAdornment: (
                            <InputAdornment position="end">
                                {value && !disabled && !readOnly && (
                                    <IconButton
                                        tabIndex={-1}
                                        onClick={() =>
                                            setValue(name, '', {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            })
                                        }
                                        sx={{ p: 0.5 }}
                                    >
                                        <IconClose />
                                    </IconButton>
                                )}
                                {iconEnd}
                                {password && (
                                    <IconButton
                                        tabIndex={-1}
                                        aria-label={`toggle ${name} visibility`}
                                        onClick={() => setShowPassword((prev) => !prev)}
                                        sx={{ p: 0.5 }}
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                )}
                            </InputAdornment>
                        ),
                    }}
                />
            }
        />
    )
}

export default ItemFormText
